import React from "react";
import {useTranslation} from "react-i18next";
import {Field, Form, Formik} from "formik";
import {CircularProgress} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import {fetchParameters, updateParameters} from "../../redux_slices/userParametersSlice";
import {getContextSilent} from "../../redux_slices/contextSlice";
import Swal from "sweetalert2";
import PasswordChecker from "../../widgets/auth/PasswordChecker";

const SecurityComponent = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const userParametersStatus = useSelector(state => state.userParameters.status);

    const onFormSubmit = async (values, {resetForm}) => {
        const parameters = {
            password: btoa(values.password),
            confirmation: btoa(values.confirmation),
        };
        await dispatch(updateParameters({values: parameters})).then(() => {
            Swal.fire({
                icon: "success",
                text: t("PROFILE.MESSAGE.PASSWORD.SUCCESS"),
            });
        });
        await dispatch(getContextSilent());
        await dispatch(fetchParameters());
    };
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(.+){8,}$/;
    const passwordRegexText = `^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(.+){8,}$`;
    const validatePassword = values => {
        if (!values) {
            return t("PROFILE.MESSAGE.PASSWORD.REQUIRED");
        } else if (!passwordRegex.test(values)) {
            return t("PROFILE.MESSAGE.PASSWORD.REQUIREMENTS");
        }
    };
    const validateConfirmPassword = (pass, value) => {
        if (pass && value) {
            if (pass !== value) {
                return t("PROFILE.MESSAGE.PASSWORD.NOTMATCH");
            }
        }
    };

    const securityInitialValues = {
        password: "",
        passwordRep: "",
        // confirmation: "",
    };

    return (
        <div className="card card-custom gutter-b shadow">
            <div className="card-header flex-wrap pt-6 pb-0 border-bottom border-gray">
                <div className="card-title">{t("PROFILE.ACCESS_METHODS")}</div>
            </div>
            {userParametersStatus.type === "succeeded" ? (
                <>
                    {/*<div className="card-body position-relative">*/}
                    {/*  <button*/}
                    {/*      type="button"*/}
                    {/*      className="btn btn-light-primary font-weight-bolder px-8 py-4 my-3 font-size-lg"*/}
                    {/*  >*/}
                    {/*    <span className="svg-icon svg-icon-md">*/}
                    {/*      <CloudIcon/>*/}
                    {/*    </span>*/}
                    {/*    Change password with Auth0*/}
                    {/*  </button>*/}
                    {/*</div>*/}
                    <div className="card-body position-relative">
                        <Formik initialValues={securityInitialValues} onSubmit={onFormSubmit}>
                            {({values, errors}) => {
                                return (
                                    <Form>
                                        <div className="form-group">
                                            <label htmlFor="newPassword">{t("PROFILE.NEW_PASS")}</label>
                                            <Field
                                                id="password"
                                                name="password"
                                                type="password"
                                                pattern={passwordRegexText}
                                                className="form-control form-control-solid h-auto py-5 px-6"
                                                validate={validatePassword}
                                            />
                                            {errors.password ? (
                                                <div className="alert alert-danger">* {errors.password}</div>
                                            ) : null}
                                            <PasswordChecker password={values.password}/>
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="repeatpassword">{t("PROFILE.REPEAT_NEW_PASS")}</label>
                                            <Field
                                                id="passwordRep"
                                                name="passwordRep"
                                                type="password"
                                                pattern={passwordRegexText}
                                                className="form-control form-control-solid h-auto py-5 px-6"
                                                validate={value => validateConfirmPassword(values.password, value)}
                                            />
                                            {errors.passwordRep ? (
                                                <div className="alert alert-danger">* {errors.passwordRep}</div>
                                            ) : null}
                                        </div>
                                        <hr/>
                                        {/*<div className="form-group">*/}
                                        {/*    <label htmlFor="password">{t("PROFILE.CONFIRM_PASS")}</label>*/}
                                        {/*    <Field*/}
                                        {/*        id="confirmation"*/}
                                        {/*        name="confirmation"*/}
                                        {/*        type="password"*/}
                                        {/*        className="form-control form-control-solid h-auto py-5 px-6"*/}
                                        {/*    />*/}
                                        {/*</div>*/}
                                        <div className="d-flex">
                                            <button type="submit" className="btn btn-primary mx-auto">
                                                {t("PROFILE.SAVE_BUTTON")}
                                            </button>
                                        </div>
                                    </Form>
                                );
                            }}
                        </Formik>
                    </div>
                </>
            ) : (
                <div className={`d-flex align-items-center justify-content-center`}>
                    <CircularProgress/>
                </div>
            )}
        </div>
    );
};
export default SecurityComponent;
